import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'filter.price.title',
    defaultMessage: 'Tarif',
  },
  minimum: {
    id: 'filter.price.minimum',
    defaultMessage: 'Minimum',
  },
  maximum: {
    id: 'filter.price.maximun',
    defaultMessage: 'Maximum',
  },
});
